<div
    [attr.id]="buildId('Container')"
    [class.has-danger]="hasErrors()"
    [class.vd-form-group-danger]="hasErrors()"
    class="form-group"
>

    <label
        *ngIf="!!label"
        [attr.for]="buildChildId()"
        [ngClass]="isLabelSrOnly ? 'visually-hidden' : labelStyleModifier"
    >
        {{ label }}
        <span *ngIf="!required" aria-hidden="true">(facultatif)</span>
    </label>

    <foehn-validation-alerts [component]="this"></foehn-validation-alerts>

    <div class="row">
        <div class="col-md-6">
            <foehn-input-date
                [(model)]="model.start"
                [label]="startLabel"
                [name]="buildChildName('start')"
                [required]="startRequired"
            >
            </foehn-input-date>
        </div>

        <div class="col-md-6">
            <foehn-input-date
                [(model)]="model.end"
                [label]="endLabel"
                [name]="buildChildName('end')"
                [required]="endRequired"
            >
            </foehn-input-date>
        </div>
    </div>

</div>
